// Contains the common configuration for search

const config = {
  debug: false,
  alwaysSearchOnInitialLoad: false,
  searchQuery: {
    includeRawHit: false,
    filters: [],
    search_fields: {
      agents: {
        weight: 3,
      },
      postcode: {
        weight: 2,
      },
      name: {
        weight: 1,
      },
      keywords: {},
    },
    result_fields: {
      address_postcode: { raw: {} },
      location_text: { raw: {} },
      postcode: { raw: {} },
      town: { raw: {} },
      // key_points: { raw: {} },
      id: { raw: {} },
      size_ft: { raw: {} },
      size_m: { raw: {} },
      rent_pa: { raw: {} },
      name: {},
      full_name: { raw: {} },
      description: { raw: {} },
      headline: { raw: {} },
      docType: { raw: {} },
      geo_location: {},
      thumbnail_url: { raw: {} },
      thumbnail_uri: { raw: {} },
      price: { raw: {} },
      // image: {},
      thumbnail: {},
      // images: { raw: {} },
      url: { raw: {} },
      uri: { raw: {} },
      "pictures.url": { raw: {} },
      search_rank: { raw: {} },
      // index_search_rank: {},
      // acres: { raw: {} },
      place_name: { raw: {} },
      place_uri: { raw: {} },
      // keywords: { raw: {} },
      availability: {},
      sponsored: {},
      // TODO Remove when available properties have images
      // properties: {},
      // available_properties: {},
      "available_properties.id": {},
      "available_properties.agents": {},
      "available_properties.name": {},
      "available_properties.availability": {},
      "available_properties.size_ft_max": {},
      // "available_properties.size_ft_min": {},
      "available_properties.size_m_max": {},
      "available_properties.url_fragment": {},
      "available_properties.rent_pa": {},
      "available_properties.thumbnail": {},
      "available_properties.paying_client": {},
      "available_properties.uri": {},
      number_of_available_properties: {},
      line1: {},
      line2: {},
      line3: {},
      town_name: {},
      category_code: {},
      modified: {},
      agents: {},
      owners: {},
     // owner_portfolios: {},
      url_fragment: {},
      premium: {},
      // price: {},
      "_source": false,

    },
    disjunctiveFacets: [
      "town.name",
      "category_code",
      // "size",
       "availability",
      // "keywords",
      // "date_established",
      // "location"
    ],
    facets: {
      // "docType": { type: "value", size: 2, sort: "count" },
      "availability": { type: "value", size: 10, sort: "count" },
      "category_code": { type: "value", size: 10, sort: "count" },
      "town.name": { type: "value", size: 50, sort: "count" },
      "rent_pa_range": {
            type: "range",
            ranges: [
              { from: 0, to: 9999.99, name: "< 10k" },
              { from: 10000, to: 20000, name: "10k - 20k" },
              { from: 20000, to: 30000, name: "20k - 30k" },
              { from: 30000, to: 40000, name: "30k - 40k" },
              { from: 40000, to: 50000, name: "40k - 50k" },
              { from: 50000, to: 60000, name: "50k - 60k" },
              { from: 60000, to: 70000, name: "60k - 70k" },
              { from: 70000, to: 80000, name: "70k - 80k" },
              { from: 80000, to: 90000, name: "80k - 90k" },
              { from: 90000, to: 100000, name: "90k - 100k" },
              { from: 110000, to: 125000, name: "100k - 125k" },
              { from: 125000, to: 150000, name: "125k - 150k" },
              { from: 150000, to: 175000, name: "150k - 175k" },
              { from: 175000, to: 200000, name: "175k - 200k" },
              { from: 200000, to: 250000, name: "200k - 250k" },
              { from: 250000, to: 300000, name: "250k - 300k" },
              { from: 300000, to: 400000, name: "300k - 400k" },
              { from: 400001, name: "> 400k" },
              
            ]
          },
          "price_range": {
            type: "range",
            ranges: [
              { from: 0, to: 100000, name: "< 100k" },
              { from: 100000, to: 200000, name: '100k - 200k'},
              { from: 200000, to: 300000, name: '200k - 300k'},
              { from: 300000, to: 400000, name: '300k - 400k'},
              { from: 400000, to: 500000, name: '400k - 500k'},
              { from: 500000, to: 600000, name: '500k - 600k'},
              { from: 600000, to: 700000, name: '600k - 700k'},
              { from: 700000, to: 800000, name: '700k - 800k'},
              { from: 800000, to: 900000, name: '800k - 900k'},
              { from: 900000, to: 1000000, name: '900k - 1m'},
              { from: 1000000, to: 1500000, name: '1m - 1.5m'},
              { from: 1500000, to: 2000000, name: '1.5m - 2.0m'},
              { from: 2000000, name: '> 2m'},
            ]
          },
          "size_ft_max_range": {
            type: "range",
            ranges: [
              { from: 0, to: 9999.99, name: "< 100" },
              { from: 100, to: 200, name: "100 - 200" },
              { from: 200, to: 300, name: "200 - 300" },
              { from: 300, to: 400, name: "300 - 400" },
              { from: 400, to: 500, name: "400 - 500" },
              { from: 500, to: 600, name: "500 - 600" },
              { from: 600, to: 700, name: "600 - 700" },
              { from: 700, to: 800, name: "700 - 800" },
              { from: 800, to: 900, name: "800 - 900" },
              { from: 900, to: 1000, name: "900 - 1000" },
              { from: 1000, to: 1250, name: "1000 - 1250" },
              { from: 1250, to: 1500, name: "1250 - 1500" },
              { from: 1500, to: 1750, name: "1500 - 1750" },
              { from: 1750, to: 2000, name: "1750 - 2000" },
              { from: 2000, to: 2500, name: "2000 - 2500" },
              { from: 2500, to: 3000, name: "2500 - 3000" },
              { from: 3000, to: 4000, name: "3000 - 4000" },
              { from: 4001, name: "> 4000" },
      
      
        
            ]
          },
          "size_m_max_range": {
            type: "range",
            ranges: [
              { from: 0, to: 9999.99, name: "< 100" },
              { from: 100, to: 200, name: "100 - 200" },
              { from: 200, to: 300, name: "200 - 300" },
              { from: 300, to: 400, name: "300 - 400" },
              { from: 400, to: 500, name: "400 - 500" },
              { from: 500, to: 600, name: "500 - 600" },
              { from: 600, to: 700, name: "600 - 700" },
              { from: 700, to: 800, name: "700 - 800" },
              { from: 800, to: 900, name: "800 - 900" },
              { from: 900, to: 1000, name: "900 - 1000" },
              { from: 1000, to: 1250, name: "1000 - 1250" },
              { from: 1250, to: 1500, name: "1250 - 1500" },
              { from: 1500, to: 1750, name: "1500 - 1750" },
              { from: 1750, to: 2000, name: "1750 - 2000" },
              { from: 2000, to: 2500, name: "2000 - 2500" },
              { from: 2500, to: 3000, name: "2500 - 3000" },
              { from: 3000, to: 4000, name: "3000 - 4000" },
              { from: 4001, name: "> 4000" },
              
            ]
          },
      // "keywords.keyword": { type: "value", size: 30, sort: "count" },
      // "agents.company.keyword": { type: "value", size: 400, sort: "count" },
      // "data_provider.keyword": { type: "value", size: 10, sort: "count" },
      // "availability.keyword": { type: "value", size: 6, sort: "count" },
      // size: {
      //   type: "range",
      //   ranges: [
      //     { from: -1, name: "Any" },
      //     { from: 0, to: 200, name: "Small" },
      //     { from: 201, to: 500, name: "Medium" },
      //     { from: 501, name: "Large" }
      //   ]
      // },
      // location: {
      //   // San Francisco. In the future, make this the user's current position
      //   center: "37.7749, -122.4194",
      //   type: "range",
      //   unit: "mi",
      //   ranges: [
      //     { from: 0, to: 100, name: "Nearby" },
      //     { from: 100, to: 500, name: "A longer drive" },
      //     { from: 500, name: "Perhaps fly?" }
      //   ]
      // },
      // rent_pa: {
      //   type: "range",
      //   ranges: [
      //     { from: 0, to: 1000, name: "0 - 1000" },
      //     { from: 1001, to: 100000, name: "10001 - 100000" },
      //     { from: 100001, to: 500000, name: "100001 - 500000" },
      //     { from: 500001, to: 1000000, name: "500001 - 1000000" },
      //     { from: 1000001, to: 5000000, name: "1000001 - 5000000" },
      //     { from: 5000001, to: 10000000, name: "5000001 - 10000000" },
      //     { from: 10000001, name: "10000001+" }
      //   ]
      // }
    },
  },
  autocompleteQuery: {
    results: {
      search_fields: {
        name: {},
        postcode: {},
      },
      resultsPerPage: 5,
      result_fields: {
        name: {
          raw: {}
          // snippet: {
          //   size: 100,
          //   fallback: true
          // }
        },
        // nps_link: {
        //   raw: {}
        // }
      },
    },
    suggestions: {
      types: {
        documents: {
          fields: ["suggest"],
        },
      },
      size: 4,
    },
  },
};


export default config;
